/* global document */
export default function readCookie(k) {
  return global.document ? (global.document.cookie.match(`(^|; )${k}=([^;]*)`) || 0)[2] : null;
}
